import { mainThemeColor } from "../../color/MainThemeColor";

const footerStyle = { bgcolor: mainThemeColor, top: "auto", bottom: 0, zIndex:1000 };

const textStyle = { color: "white", fontSize: "10px" }

export { footerStyle, textStyle };
